module.exports = __webpack_public_path__ + "static/media/crowd.47bbce58.png";